import React from "react";
import { Link } from "react-router-dom";

const AccesoDirecto = ({ href, label, icon, disabled }) => {
    return(
        <Link
            to={!disabled ? href : null}
            className="
                w-full h-44 flex flex-col items-center justify-center p-4 text-center bg-rs-azul rounded-lg hover:bg-rs-rojo shadow-md
                transition transform hover:scale-105 shadow-black hover:shadow-xl hover:shadow-rs-rojo"
        >
            {React.createElement(icon, { size: 40, color: "white" })}
            <h2 className="text-white text-lg font-bold">{label}</h2>
        </Link>
    );
};

export default AccesoDirecto;